<template>
	<span>
		<div>
			<img src="@/assets/logo_seculos.png" class="img-logo" height="52" />
		</div>
	</span>
</template>
<script>
export default {
	computed: {},
	methods: {},
}
</script>
<style>
.img-logo {
	vertical-align: middle;
}
</style>